const translations: Record<string, string> = {
  "ak_fin_guaranteed_buyer": "Гарантований покупець",
  "ak_fin_trader": "Трейдер",
  "ak_fin_aggregator": "Агрегатор",
  "ak_fin_green_tariff": "Зелений тариф",
  "ak_fin_bilateral_contract": "Двосторонній договір",
  "ak_fin_fixed": "Фіксована",
  "ak_fin_formula": "Формульна",
  "ak_fin_dam": "РДН",
  "ak_fin_other_index": "Інший індекс",
  "ak_fin_draft": "Чернетка",
  "ak_fin_active": "Чинний",
  "ak_fin_completed": "Завершений",
  "ak_fin_uah": "грн",
  "ak_fin_finance": "Фінанси",
  "ak_fin_financial_result": "Фінансовий результат",
  "ak_fin_select_a_station_in_the_header_to_see": "Оберіть станцію у шапці, щоб побачити фінансовий результат.",
  "ak_fin_loading": "Завантаження…",
  "ak_fin_lost_benefit": "Втрачена вигода",
  "ak_fin_the_indicator_will_be_implemented_in_t": "Показник буде реалізовано в наступному релізі. Наразі втрачена вигода дорівнює 0 грн і не впливає на розрахунок фінансового результату.",
  "ak_fin_financial_result_comprehensive": "Фінансовий результат (комплексний)",
  "ak_fin_in_the_next_release_planned_and_actual": "У наступному релізі: плановий та фактичний дохід, небаланси, втрачена вигода, компенсації ОСП/ОСР, результат роботи УЗЕ та підсумковий фінансовий результат.",
  "ak_fin_next_release": "наступний реліз",
  "ak_fin_0_uah": "0 грн",
  "ak_fin_with_vat": "з ПДВ",
  "ak_fin_without_vat": "без ПДВ",
  "ak_fin_planned_income": "Плановий дохід",
  "ak_fin_imbalances_actual": "Небаланси (факт.)",
  "ak_fin_imbalances": "Небаланси",
  "ak_fin_failed_to_save": "Не вдалося зберегти",
  "ak_fin_actual_settlement_from_the_group": "Фактичний розрахунок від групи",
  "ak_fin_imbalance_volume_positive_surplus_nega": "Обсяг небалансу: додатний — надлишок, від’ємний — дефіцит. Суму можна лишити порожньою — порахується як обсяг × ціна.",
  "ak_fin_hr": "Год",
  "ak_fin_imbalance_kwh": "Небаланс, кВт·год",
  "ak_fin_price_uah_mwh": "Ціна, грн/МВт·год",
  "ak_fin_amount_uah": "Сума, грн",
  "ak_fin_close": "Закрити",
  "ak_fin_saving": "Збереження…",
  "ak_fin_save": "Зберегти",
  "ak_fin_hour": "Година {{label}}",
  "ak_fin_plan_mwh": "План: {{v}} МВт·год",
  "ak_fin_delivery_mwh": "Відпуск: {{v}} МВт·год",
  "ak_fin_imbalance_mwh": "Небаланс: {{v}} МВт·год",
  "ak_fin_day": "День {{label}}",
  "ak_fin_operational": "Оперативний: {{v}}",
  "ak_fin_plan": "План",
  "ak_fin_delivery": "Відпуск",
  "ak_fin_imbalance": "Небаланс",
  "ak_fin_operational_result": "Оперативний результат",
  "ak_fin_mms_release_mwh": "Відпуск MMS: {{v}} МВт·год",
  "ak_fin_price_uah_mwh_2": "Ціна: {{v}} грн/МВт·год",
  "ak_fin_price_type": "Тип ціни: {{v}}",
  "ak_fin_planned_income_2": "Плановий дохід (без ПДВ): {{v}}",
  "ak_fin_current_cost": "Актуальна вартість: {{v}}",
  "ak_fin_actual_cost": "Фактична вартість: {{v}}",
  "ak_fin_difference": "Різниця: {{v}}",
  "ak_fin_k": "к",
  "ak_fin_release_mwh": "Відпуск, МВт·год",
  "ak_fin_income_uah": "Дохід, грн",
  "ak_fin_cost_uah": "Вартість, грн",
  "ak_fin_mms_release": "Відпуск MMS",
  "ak_fin_current_cost_2": "Актуальна вартість",
  "ak_fin_actual_cost_2": "Фактична вартість",
  "ak_fin_metric_hour": "Показник \\ Год",
  "ak_fin_metric_date": "Показник \\ Дата",
  "ak_fin_the_accepted_mms_release_schedule": "— прийнятий MMS графік відпуску",
  "ak_fin_per_contract_terms_gt_fixed_formula": "— за умовами договору (ЗТ / фікс. / формульна)",
  "ak_fin_release_price": "відпуск × ціна",
  "ak_fin_release_price_release": "Σ(відпуск × ціна) / Σ відпуску",
  "ak_fin_total": "Всього",
  "ak_fin_mms_release_mwh_2": "Відпуск MMS, МВт·год",
  "ak_fin_weighted_avg_price_uah_mwh": "Середньозв. ціна, грн/МВт·год",
  "ak_fin_planned_income_uah": "Плановий дохід, грн (без ПДВ)",
  "ak_fin_accumulated_uah": "Накопичено, грн",
  "ak_fin_no_data_for_the_period": "Немає даних за період.",
  "ak_fin_no_data_for_the_chart": "Немає даних для графіка",
  "ak_fin_sale_price": "Ціна продажу",
  "ak_fin_weighted_average": "Середньозважена",
  "ak_fin_for_the_day": "за добу · {{d}}",
  "ak_fin_for_the_day_2": "за добу",
  "ak_fin_as_of": "станом на {{d}}",
  "ak_fin_as_of_today": "станом на сьогодні",
  "ak_fin_imbalances_since_month_start": "Небаланси з початку місяця",
  "ak_fin_economic_effect": "Економічний ефект",
  "ak_fin_after_the_month_is_closed": "після закриття місяця",
  "ak_fin_current_cost_uah": "Актуальна вартість, грн",
  "ak_fin_actual_cost_uah": "Фактична вартість, грн",
  "ak_fin_difference_uah": "Різниця, грн",
  "ak_fin_current_month": "поточний місяць",
  "ak_fin_imbalance_result_actual": "Результат небалансів (факт.)",
  "ak_fin_current_imbalance_result": "Поточний результат небалансів",
  "ak_fin_month_closed_auto": "Місяць закрито (авто)",
  "ak_fin_month_closed": "Місяць закрито",
  "ak_fin_month_open": "Місяць відкрито",
  "ak_fin_manually_close_reopen_the_month": "Ручне закриття/відкриття місяця",
  "ak_fin_reopen_month": "Відкрити місяць",
  "ak_fin_close_month": "Закрити місяць",
  "ak_fin_after_the_month_is_closed_the_actual_i": "Після закриття місяця відображається фактична вартість небалансів та економічний ефект.",
  "ak_fin_before_the_month_is_closed_the_platfor": "До закриття місяця платформа автоматично показує актуальну вартість небалансів (оперативну або уточнену).",
};

export default translations;
